module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAShJREFUGBljZEACc+fOtfn7928LIyMjG1D4OxBXp6amnoApYYIxZs2apfbv378uVlbWCKACKyYmptj////3LliwQBmmBq4YKJAAlGxMTEx8AZJMTk5+BqTaf//+HQXigwCyYmagae8hwhCSmZn5A9BJAjAxuGKgwl1Ak7OBmBEkCaKBzsoC0lthisESMA7Q3X1AkyyBCo4DaTMgvTktLa0TJg82+cyZM6yzZ8+eBFRgAsSbgJI72djY/EEKgQYUgWwBaWABEefPn18NpA6kpKTkAxX/B4nBAJAfcODAgUlA/h/GOXPmRAB12gCDKwemAEQDxQuB4mFApjaQvgbU9JgBaP1eYGRIIStEZgPlj6xatYoZJAZy81domCKrgbOBpt4MDQ39BxIAADjnfR1WkxBuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/bmicon.png
// module id = cz0u
// module chunks = 1